import React from "react";
import "../../scss/Dashboard.css";
import Navbar from "../../components/Navbar";
import AttendanceSubReport from "./AttendanceSubReport";

const EventReport = () => {

  return (
    <div>
      <Navbar />
      <div class="container mid-title card-b-1">
        <div class="mid-title-left">Attendance Reports</div>
        <div class="crl"></div>
        <div class="row">
          <div class="col-sm-12 r-text">
          Welcome to your reporting page. Here you will find a selection of reports that you can view and download into excel to help you work with your suppliers as well as plan and budget for every one of your events.
          </div>
        </div>
      </div>
      <div class="main-container">
        <div class="container bg-w">


          <AttendanceSubReport />
        </div>
      </div>
    </div>
  );
};

export default EventReport;
